// extracted by mini-css-extract-plugin
export default {"label":"styles_label__ueBBk","description":"styles_description__em99u"};